import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from './components/routes/Layout';
import NoPage from './components/routes/NoPage';

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />} />
                <Route path="/:eventKey" element={<Layout />} />
                <Route path="*" element={<NoPage />} />
            </Routes>
        </BrowserRouter>
    );
}